export default {"src":"/_next/static/media/hug.3b4b6cc8.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};